var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "splicing-table" },
    [
      _c(
        "div",
        {
          staticClass:
            "splicing-table-inner-container d-flex justify-space-between mb-4"
        },
        [
          _c("h2", { staticClass: "splicing-table-title" }, [
            _vm._v("Splicing")
          ]),
          _vm._v(" "),
          _c(
            "div",
            [
              _c(
                "v-btn",
                {
                  style: { "text-transform": "none" },
                  attrs: { color: "accent", loading: _vm.btnLoading },
                  on: { click: _vm.openClosureToExport }
                },
                [
                  _c("v-icon", [_vm._v("mdi-download")]),
                  _vm._v("\n                Export\n            ")
                ],
                1
              )
            ],
            1
          )
        ]
      ),
      _vm._v(" "),
      _vm._m(0),
      _vm._v(" "),
      _c("v-data-table", {
        staticClass: "splicing-data-table elevation-1",
        style: { height: "100%" },
        attrs: {
          headers: _vm.headers,
          items: _vm.allConnections,
          "items-per-page": _vm.rowsPerPage,
          "items-per-page-text": _vm.rowsPerPageText,
          "items-per-page-items": _vm.rowsPerPageItems,
          loading: _vm.loading,
          "footer-props": {
            "items-per-page-options": [15, 50, 100]
          }
        },
        on: {
          "update:itemsPerPage": function($event) {
            _vm.rowsPerPage = $event
          },
          "update:items-per-page": function($event) {
            _vm.rowsPerPage = $event
          }
        },
        scopedSlots: _vm._u([
          {
            key: "item",
            fn: function(props) {
              return [
                _c("tr", [
                  _c("td", [_vm._v(_vm._s(props.item.trayMaterial))]),
                  _vm._v(" "),
                  _c("td", [_vm._v(_vm._s(props.item.trayLabel))]),
                  _vm._v(" "),
                  _c("td", [_vm._v(_vm._s(props.item.trayFace))]),
                  _vm._v(" "),
                  _c("td", [_vm._v(_vm._s(props.item.trayNumber))]),
                  _vm._v(" "),
                  _c("td", [_vm._v(_vm._s(props.item.trayPosition))]),
                  _vm._v(" "),
                  _c("td", { staticClass: "type-row" }, [
                    _vm._v(_vm._s(props.item.originType))
                  ]),
                  _vm._v(" "),
                  _c("td", [
                    _vm._v(
                      _vm._s(
                        _vm.getMaterialName(
                          props.item.originMaterial,
                          props.item.originConnectionType
                        )
                      )
                    )
                  ]),
                  _vm._v(" "),
                  _c("td", [_vm._v(_vm._s(props.item.originLabel))]),
                  _vm._v(" "),
                  props.item.originConnectionType === "fiber"
                    ? _c("td", [
                        _c("div", { staticClass: "d-flex align-center" }, [
                          props.item.originTubeColor
                            ? _c("span", {
                                staticClass: "cube cube-right",
                                style: {
                                  "background-color": _vm.getTubeColor(
                                    props.item.originTubeColor
                                  )
                                }
                              })
                            : _vm._e(),
                          _vm._v(" "),
                          props.item.originFiberColor
                            ? _c("span", {
                                staticClass: "circle circle-right",
                                style: {
                                  "background-color": _vm.getFiberColor(
                                    props.item.originFiberColor
                                  )
                                }
                              })
                            : _vm._e(),
                          _vm._v(" "),
                          _c("div", { style: { minWidth: "58px" } }, [
                            _vm._v(
                              "\n                        " +
                                _vm._s(props.item.originIdentificators) +
                                "\n                    "
                            )
                          ])
                        ])
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  props.item.originConnectionType === "port"
                    ? _c("td", [
                        _c("div", { staticClass: "d-flex align-center" }, [
                          _c("span", {
                            staticClass: "triangle triangle-right"
                          }),
                          _vm._v(
                            "\n                    " +
                              _vm._s(props.item.originIdentificators) +
                              "\n                "
                          )
                        ])
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _c("td", { staticClass: "type-row" }, [
                    _vm._v(_vm._s(props.item.mode))
                  ]),
                  _vm._v(" "),
                  props.item.destinationConnectionType === "fiber"
                    ? _c("td", { staticClass: "type-row" }, [
                        _c("div", { staticClass: "d-flex align-center" }, [
                          _c("div", { style: { minWidth: "58px" } }, [
                            _vm._v(
                              "\n                        " +
                                _vm._s(props.item.destinationIdentificators) +
                                "\n                    "
                            )
                          ]),
                          _vm._v(" "),
                          props.item.destinationFiberColor
                            ? _c("span", {
                                staticClass: "circle circle-left",
                                style: {
                                  "background-color": _vm.getFiberColor(
                                    props.item.destinationFiberColor
                                  )
                                }
                              })
                            : _vm._e(),
                          _vm._v(" "),
                          props.item.destinationTubeColor
                            ? _c("span", {
                                staticClass: "cube cube-left",
                                style: {
                                  "background-color": _vm.getTubeColor(
                                    props.item.destinationTubeColor
                                  )
                                }
                              })
                            : _vm._e()
                        ])
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  props.item.destinationConnectionType === "port"
                    ? _c("td", { staticClass: "type-row" }, [
                        _c("div", { staticClass: "d-flex align-center" }, [
                          _vm._v(
                            "\n                    " +
                              _vm._s(props.item.destinationIdentificators) +
                              "\n                    "
                          ),
                          _c("span", { staticClass: "triangle triangle-left" })
                        ])
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _c("td", [_vm._v(_vm._s(props.item.destinationLabel))]),
                  _vm._v(" "),
                  _c("td", [
                    _vm._v(
                      _vm._s(
                        _vm.getMaterialName(
                          props.item.destinationMaterial,
                          props.item.destinationConnectionType
                        )
                      )
                    )
                  ]),
                  _vm._v(" "),
                  _c("td", [_vm._v(_vm._s(props.item.destinationType))])
                ])
              ]
            }
          },
          {
            key: "pageText",
            fn: function(props) {
              return [
                _vm._v(
                  "\n        " +
                    _vm._s(props.pageStart) +
                    " - " +
                    _vm._s(props.pageStop) +
                    " " +
                    _vm._s(_vm.$t("tables.Of")) +
                    "\n        " +
                    _vm._s(props.itemsLength) +
                    "\n    "
                )
              ]
            }
          }
        ])
      })
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "splicing-titles-container" }, [
      _c("div", { staticClass: "splicing-titles-tray" }, [
        _c("p", { staticClass: "title-tray-item" }, [_vm._v("Tray")])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "splicing-titles-origin" }, [
        _c("p", { staticClass: "title-tray-origin" }, [_vm._v("Origin")])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "splicing-titles-destination" }, [
        _c("p", { staticClass: "title-tray-origin" }, [_vm._v("Destination")])
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-294d15b6", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-294d15b6","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Home/Forms/_SpecialTabs/Splicing/SplicingTable.vue
// module id = null
// module chunks = 